<template>
  <div
    class="buildings"
  >
    <ul class="buildings-ul">
      <li
        v-for="building in displayBuildings"
        :key="building.objectId"
        class="buildings-li"
        :class="{
          'buildings-li-active': handleLiActive(building.objectId)
        }"
      >
        <a
          role="button"
          class="buildings-a"
          :title="building.name"
          @click="selectBuilding({buildingId: building.objectId})"
        >{{ building.nameMulti[$i18n.locale] || building.name }}</a>
      </li>
      <li class="buildings-underline" />
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ViewerListBuildings',
  data () {
    return {
      isBuildingsReady: false
    }
  },
  computed: {
    ...mapGetters([
      'currentBuilding',
      'isKrpanoActive',
      'property',
      'user'
    ]),
    displayBuildings () {
      return this.property.buildings.map(this.formatBuilding)
    }
  },
  mounted () {
    this.isBuildingsReady = true
  },
  methods: {
    ...mapActions([
      'selectBuilding'
    ]),
    handleLiActive (id) {
      // HARD CODE: 當目前顯示的是未來科技館 2 的 LT 時候，要讓未來科技館 1 的 li 顯示 active
      if (this.currentBuilding.objectId === '324ff76d-1e9d-4ac8-a2ed-c0a2f6353755') {
        return id === 'f71bb4b0-0a75-46aa-a5b8-7cd4f37a96d2'
      } else {
        return id === this.currentBuilding.objectId
      }
    },
    formatBuilding (building) {
      const copyBuilding = JSON.parse(JSON.stringify(building))
      copyBuilding.nameMulti = typeof copyBuilding.nameMulti === 'string'
        ? JSON.parse(copyBuilding.nameMulti)
        : typeof copyBuilding.nameMulti === 'object' ? copyBuilding.nameMulti : {}
      return copyBuilding
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/addon/main'
@import '~css/common/extends'

.buildings {
  position: relative
  width: 100%
  overflow-x: auto
  width: 100%
  -webkit-overflow-scrolling: touch
  background-color: rgba(0,0,0,.2)
  z-index: $buildings-z

  //@media (min-width: $response) {
  //  width: calc(100% - 120px)
  //  border-radius: 0 1.75rem 0 0
  //}
}

.buildings-ul {
  white-space: nowrap
}

.buildings-li {
  position: relative
  width: $buildings-buildings-li-width
  text-align: center
  padding: 5px 0
  display: inline-flex

  & + .buildings-li {
    a {
    border-left-width: $buildings-buildings-li-border-width
    border-left-style: solid
    border-left-color: alpha($white, 70%)
    border-right-width: 0
    border-right-style: solid
    border-right-color: alpha($white, 70%)
    }
  }

  &:hover, &:active {
    ~ .buildings-underline {
      transition: transform .2s ease-out .1s
    }
  }

  for num in (1..$max-buildings-in-group) {
    &:nth-child({num}) {
      &.buildings-li-active {
        ~ .buildings-underline {
          transform: translateX($buildings-buildings-li-width * (num - 1))
        }
      }
    }
  }
}

.buildings-a {
  @extend .full
  @extend .text-ellipsis
  @extend .btn-no-default

  position: relative
  display: block
  padding: 2px 10px
  font-size: 14px
  color: $white
  line-height: 20px
  text-align: center
}

.buildings-underline {
  position: absolute
  left: -100%
  bottom: 0
  width: $buildings-buildings-li-width
  height: 4px
  z-index: $buildings-underline-z
  background-color: $pink-color
  transition: transform .3s ease-out

  .buildings-li-active ~ & {
    left: $buildings-buildings-underline-pos
  }
}

@media (min-width: $response) {
  .buildings-li {
    width: $buildings-buildings-li-width-large

    for num in (1..$max-buildings-in-group) {
      &:nth-child({num}) {
        &.buildings-li-active {
          ~ .buildings-underline {
            transform: translateX($buildings-buildings-li-width-large * (num - 1))
          }
        }
      }
    }
  }

  .buildings-underline {
    width: $buildings-buildings-li-width-large
  }
}
</style>

<style lang="stylus" rel="stylesheet/stylus">
@import '~css/addon/main'

$max-buildings-in-group = 20 // a group can include max 20 buildings
.theme-rtl.theme-rtl-overlap {
  .buildings-li {
    for num in (1..$max-buildings-in-group) {
      &:nth-child({num}) {
        &.buildings-li-active {
          ~ .buildings-underline {
            transform: translateX(-($buildings-buildings-li-width * (num - 1)))
          }
        }
      }
    }

    & + .buildings-li {
      border-left-width: 0
      border-right-width: $buildings-buildings-li-border-width
    }
  }

  .buildings-underline {
    left: auto
    right: $buildings-buildings-underline-pos
  }

  @media (min-width: $response) {
    .buildings-li {
      for num in (1..$max-buildings-in-group) {
        &:nth-child({num}) {
          &.buildings-li-active {
            ~ .buildings-underline {
              transform: translateX(-($buildings-buildings-li-width-large * (num - 1)))
            }
          }
        }
      }
    }
  }
}
</style>
